import React from 'react';

interface IconProps {
  fill: string;
  height: string | number;
  width: string | number;
}

function RepaymentIcon({ fill, height, width }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 34 28">
      <path
        fill={fill}
        d="M10.5 22.583H13v-1.875h2c.445 0 .8-.166 1.063-.5.264-.333.396-.708.396-1.125v-4.791c0-.445-.132-.827-.396-1.146-.264-.32-.618-.48-1.062-.48H9.376V9.793h7.083v-2.5h-3.458V5.417h-2.5v1.875h-2c-.445 0-.827.166-1.146.5-.32.333-.48.722-.48 1.166v4.75c0 .445.16.799.48 1.063.32.264.701.396 1.146.396h5.458v3.041H6.876v2.5H10.5v1.875zm13.584-1.458l2.5-2.5h-5l2.5 2.5zm-2.5-11.333h5l-2.5-2.5-2.5 2.5zM2.834 27.333c-.667 0-1.25-.25-1.75-.75s-.75-1.083-.75-1.75V3.167c0-.667.25-1.25.75-1.75s1.083-.75 1.75-.75h28.333c.667 0 1.25.25 1.75.75s.75 1.083.75 1.75v21.666c0 .667-.25 1.25-.75 1.75s-1.083.75-1.75.75H2.834z"
      ></path>
    </svg>
  );
}

export default RepaymentIcon;
